export const SPONSORSHIP_BONUS_AMOUNT = 3;
export const SPONSORSHIP_BONUS_PERCENT = 10;
export const SPONSORSHIP_PURCHASE_THRESHOLD = 10;

export const SPONSORSHIP_START_DATE = '01/05/2020';

export const SPONSORSHIP_IS_BOOSTED_OPERATION = true;
export const SPONSORSHIP_BOOSTED_OPERATION_END_DATE = '2020-10-31 23:59:59';
export const SPONSORSHIP_BOOSTED_BONUS_AMOUNT = 5;



// WEBPACK FOOTER //
// ./src/constants/sponsorship.js